export default function AnnualOperationalTotal({ rows = [], value, loading, error, metric, year, color }) {
  const records = rows.filter(row => row.year === year);
  const total = value !== undefined ? value : records.some(row => row[metric] == null) ? null : records.reduce((sum, row) => sum + row[metric], 0);
  return <div className="mt-3 border-t border-gray-800 pt-2">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="text-[12px] font-bold uppercase italic text-gray-500">Total ( Ano )</p>
      <p className={`${color} font-mono text-lg font-bold italic tracking-tighter`}>
        {loading ? 'Carregando...' : error || total == null ? 'Não informado' : total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
      </p>
    </div>
    
    {error && <p role="alert" className="mt-2 text-xs text-red-300">{error}</p>}
  </div>;
}
